import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import EasyEstimateEstimateShell from '../components/easyEstimate/EasyEstimateEstimateShell';
import { getEstimate, type EstimateFull } from '../services/estimateService';
import { clearIntentOpenVerifiedPositionsPage } from '../utils/easyEstimateVerifiedIntent';

/**
 * Widok kosztorysu w module EasyEstimate — osobna ścieżka od /app/estimates.
 */
const EasyEstimateEstimateDetailPage: React.FC = () => {
  const { estimateId } = useParams<{ estimateId: string }>();
  const navigate = useNavigate();
  const [fullEstimate, setFullEstimate] = useState<EstimateFull | null>(null);
  const [loading, setLoading] = useState(true);

  const reloadEstimate = useCallback(async () => {
    if (!estimateId) return;
    const full = await getEstimate(Number(estimateId));
    setFullEstimate(full);
  }, [estimateId]);

  useEffect(() => {
    clearIntentOpenVerifiedPositionsPage();
  }, [estimateId]);

  useEffect(() => {
    const load = async () => {
      if (!estimateId) {
        navigate('/app/easy-estimate');
        return;
      }

      try {
        setLoading(true);
        await reloadEstimate();
      } catch (err) {
        console.error('Błąd podczas ładowania kosztorysu:', err);
        navigate('/app/easy-estimate');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [estimateId, navigate, reloadEstimate]);

  if (loading) {
    return (
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', p: 3 }}>
        <Typography sx={{ fontFamily: 'Roboto, sans-serif', fontSize: '14px', color: '#5F6368' }}>
          Ładowanie…
        </Typography>
      </Box>
    );
  }

  if (!fullEstimate) {
    return null;
  }

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        /** Pełna wysokość obszaru `main` (dla /estimate/ layout zeruje padding); scroll zostaje w tabeli, sticky działa. */
        height: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <EasyEstimateEstimateShell estimate={fullEstimate} onEstimateSaved={reloadEstimate} />
    </Box>
  );
};

export default EasyEstimateEstimateDetailPage;
